import { Box, styled } from '@mui/material';

export const profileMenuProps = {
    elevation: 0,
    sx: {
        overflow: 'visible',
        width: '250px',
        filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.42))',
        background: (theme) => theme.palette.backgrounds.htBgGradient,
        backgroundColor: 'black',
        mt: 1.5,
        '& .MuiAvatar-root': {
            width: 32,
            height: 32,
            ml: -0.5,
            mr: 1,
        },
        '&:before': {
            content: '""',
            display: 'block',
            position: 'absolute',
            top: 0,
            right: 14,
            width: 10,
            height: 10,
            backgroundColor: 'backgrounds.bg1',
            transform: 'translateY(-50%) rotate(45deg)',
            zIndex: 0,
        },
    },
};

export const UserNameBox = styled(Box)({
    display: 'flex',
    gap: '8px',
});

export const ContentWrapper = styled(Box)(({ theme }) => ({
    // background: theme.palette.backgrounds.htBgGradient,
    padding: '12px 8px',
    maxWidth: '270px',
}));
export const CustomAvatar = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    width: '16px',
    height: '16px',
    backgroundColor: theme.palette.secondary.main,
    color: 'common.white',
    fontWeight: 700,
    fontSize: '12px',
}));
